<template>
  <div class="flex flex-wrap mb-2">
    <div ref="BeAndCon" class="w-full lg:w-3/4 flex-1 min-w-0 bg-white rounded-xl space-y-6 p-3 lg:p-6" style="position:relative">
      <loading :active="!showDsaLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="false"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading>
      <div>
        <span class="text-grap-700 align-middle">{{ lang['components']['Event']['BenefitsAndInvestment']['title'] }}</span>
        <div v-if="editPageType == 'false'" class="float-right text-blue-500 text-sm cursor-pointer">
          <a href="https://www.facebook.com/settings/?tab=financial_services&country=TW&show_dialog=false&show_recommendable_nux=false" target="_blank">{{ lang['components']['Event']['BenefitsAndInvestment']['go_to_verification_page'] }}</a>
        </div>
      </div>
      <div class="flex-1 space-y-4">
        <div>
          <div class="flex items-center space-x-4">
            <div class="mt-2">
              <InputSwitch :disabled="editPageType" v-model="viewDatalistData.toTaiwan"/>
            </div>
            <div class="text-sm leading-6 text-gray-400">{{ lang['components']['Event']['BenefitsAndInvestment']['deliver_countries_text'] }}</div>
          </div>
        </div>

        <div v-if="viewDatalistData.toTaiwan === true">
          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">{{ lang['components']['Event']['BenefitsAndInvestment']['select_deliver_region'] }}</label>
            <MultiSelect
              appendTo="body"
              v-model="viewDatalistData.regulated_countries"
              :options="regulatedCountryOptions"
              optionLabel="name"
              optionValue="code"
              display="chip"
              class="w-full lg:w-1/2 rounded-md mt-2"
              :placeholder="lang['components']['Event']['BenefitsAndInvestment']['placeholder_select']"
              :disabled="editPageType"
            />
          </div>

          <div class="mb-4">
            <div class="flex items-center space-x-4">
              <div class="mt-2">
                <InputSwitch :disabled="editPageType" v-model="viewDatalistData.useFinance"/>
              </div>
              <div class="text-sm leading-6 text-gray-400">{{ lang['components']['Event']['BenefitsAndInvestment']['finance_ad_text'] }}</div>
            </div>
          </div>

          <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700">{{ lang['components']['Event']['BenefitsAndInvestment']['select_fill_type'] }}</label>
            <Dropdown 
              appendTo="body"
              v-model="viewDatalistData.person_or_business" 
              :options="options" 
              optionLabel="label" 
              class="w-full rounded-md mt-2"
              :placeholder="lang['components']['Event']['BenefitsAndInvestment']['placeholder_select']"
              :disabled="editPageType"
            />
          </div>
          <div v-show="businessShow" class="border rounded-xl p-2">
            <div class="text-right">
              <button
                v-if="!editPageType"
                class="text-blue-600 focus:outline-none rounded-xl px-2 py-0.5 text-white transition duration-500 ease-in-out border border-blue-600 text-sm"
                @click="dsa_entities_update">
                <i class="pi pi-refresh text-sm"></i>
                {{ lang['components']['Event']['BenefitsAndInvestment']['update_btn'] }}
              </button>
              <i
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="lang['components']['Event']['BenefitsAndInvestment']['refresh_tooltip']"
              ></i>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-2">
              <div>
                <span v-if="editPageType == 'false'" class="text-red-500">*</span>
                <span class="text-sm">{{ lang['components']['Event']['BenefitsAndInvestment']['beneficiary_label'] }}</span>
                <i
                   v-if="editPageType == 'false'"
                  class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                  v-tooltip.top="lang['components']['Event']['BenefitsAndInvestment']['beneficiary_tooltip']"
                ></i>
                <Dropdown
                  appendTo="body"
                  :disabled="editPageType"
                  v-model="viewDatalistData.benefits"
                  :options="viewDatalistData.benefits_list"
                  :filter="true"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="-"
                  class="w-full rounded-md"
                />
              </div>

              <div>
                <span v-if="editPageType == 'false'" class="text-red-500">*</span>
                <span class="text-sm">{{ lang['components']['Event']['BenefitsAndInvestment']['payer_label'] }}</span>
                <i
                   v-if="editPageType == 'false'"
                  class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                  v-tooltip.top="lang['components']['Event']['BenefitsAndInvestment']['payer_tooltip']"
                ></i>
                <Dropdown
                  appendTo="body"
                  :disabled="editPageType"
                  v-model="viewDatalistData.investment"
                  :options="viewDatalistData.investment_list"
                  :filter="true"
                  optionLabel="name"
                  optionValue="code"
                  placeholder="-"
                  class="w-full rounded-md"
                />
              </div>
            </div>
          </div>

          <div v-show="personalShow" class="border rounded-xl p-2">
            <div class="text-right pb-2">
              <button
                v-if="!editPageType"
                class="text-blue-600 focus:outline-none rounded-xl px-2 py-0.5 text-white transition duration-500 ease-in-out border border-blue-600 text-sm"
                @click="dsa_identities_update">
                <i class="pi pi-refresh text-sm"></i>
                {{ lang['components']['Event']['BenefitsAndInvestment']['update_btn'] }}
              </button>
              <i
                v-if="!editPageType"
                class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                v-tooltip.top="lang['components']['Event']['BenefitsAndInvestment']['refresh_tooltip']"
              ></i>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-2">
              <div class="border rounded-xl p-4">
                <div v-show="viewDatalistData?.beneOrPayerPersonalList.length > 0" class="border rounded-xl p-4 mb-4">
                  <h2 class="text-lg font-semibold text-gray-700 mb-4">
                    {{ lang['components']['Event']['BenefitsAndInvestment']['select_verified_beneficiary'] }}
                    <span v-show="viewDatalistData.showKeyinBeneficiary === false && !editPageType" class="text-sm font-normal float-right cursor-pointer text-blue-600" @click="viewDatalistData.showKeyinBeneficiary = true">{{ lang['components']['Event']['BenefitsAndInvestment']['manual_input'] }}</span>
                  </h2>
                  <Dropdown 
                    appendTo="body"
                    v-model="viewDatalistData.selectedBeneficiary" 
                    :options="viewDatalistData.beneOrPayerPersonalList" 
                    optionLabel="name" 
                    optionValue="code"
                    class="w-full rounded-md"
                    placeholder="-"
                    @update:modelValue="onBeneficiaryChange"
                    :disabled="editPageType"
                  />
                </div>
                <div v-show="viewDatalistData.showKeyinBeneficiary === true" class="border rounded-xl p-4">
                  <h2 class="text-lg font-semibold text-gray-700 mb-4">{{ lang['components']['Event']['BenefitsAndInvestment']['enter_beneficiary_id_name'] }}</h2>
                  <div class="mb-3">
                    <label class="block text-sm font-medium text-gray-700">{{ lang['components']['Event']['BenefitsAndInvestment']['beneficiary_name'] }}</label>
                    <InputText 
                      v-model="viewDatalistData.beneficiary_name" 
                      class="w-full mt-1 rounded-md" 
                      placeholder="-"
                      :disabled="editPageType"
                      v-on:keyup="isChangeData('b')"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700">{{ lang['components']['Event']['BenefitsAndInvestment']['beneficiary_id'] }}</label>
                    <InputText 
                      v-model="viewDatalistData.beneficiary_id" 
                      class="w-full mt-1 rounded-md" 
                      placeholder="-"
                      :disabled="editPageType"
                      v-on:keyup="isChangeData('b')"
                    />
                  </div>
                </div>
              </div>

              <div class="border rounded-xl p-4">
                <div v-show="viewDatalistData?.beneOrPayerPersonalList.length > 0" class="border rounded-xl p-4 mb-4">
                  <h2 class="text-lg font-semibold text-gray-700 mb-4">
                    {{ lang['components']['Event']['BenefitsAndInvestment']['select_verified_payer'] }}
                    <span v-show="viewDatalistData.showKeyinPayer === false && !editPageType" class="text-sm font-normal float-right cursor-pointer text-blue-600" @click="viewDatalistData.showKeyinPayer = true">{{ lang['components']['Event']['BenefitsAndInvestment']['manual_input'] }}</span>
                  </h2>
                  <Dropdown 
                    appendTo="body"
                    v-model="viewDatalistData.selectedPayer" 
                    :options="viewDatalistData.beneOrPayerPersonalList" 
                    optionLabel="name" 
                    optionValue="code"
                    class="w-full rounded-md"
                    placeholder="-"
                    @update:modelValue="onPayerChange"
                    :disabled="editPageType"
                  />
                </div>
                <div v-show="viewDatalistData.showKeyinPayer === true" class="border rounded-xl p-4">
                  <h2 class="text-lg font-semibold text-gray-700 mb-4">{{ lang['components']['Event']['BenefitsAndInvestment']['enter_payer_id_name'] }}</h2>
                  <div class="mb-3">
                    <label class="block text-sm font-medium text-gray-700">{{ lang['components']['Event']['BenefitsAndInvestment']['payer_name'] }}</label>
                    <InputText 
                      v-model="viewDatalistData.payer_name" 
                      class="w-full mt-1 rounded-md" 
                      placeholder="-"
                      :disabled="editPageType"
                      v-on:keyup="isChangeData('p')"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700">{{ lang['components']['Event']['BenefitsAndInvestment']['payer_id'] }}</label>
                    <InputText 
                      v-model="viewDatalistData.payer_id" 
                      class="w-full mt-1 rounded-md" 
                      placeholder="-"
                      :disabled="editPageType"
                      v-on:keyup="isChangeData('p')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
    <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar"></div>
  </div>
</template>
<script>
  import InputSwitch from 'primevue/inputswitch';
  import Dropdown from "primevue/dropdown";
  import MultiSelect from "primevue/multiselect";

  import Card from 'primevue/card';
  import InputNumber from 'primevue/inputnumber';
  import InputText from 'primevue/inputtext';
  import Button from 'primevue/button';
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'StageDoForward',
    props: {
      editPage: {
        type: Boolean,
        default: false, // 默認值
      },
      viewDatalist: {
        type: Object,
        default: () => ({}), // 默認空對象
      },
      locale: {
        type: String,
        default: '',
      },
      lang: {
        type: Object,
        default: () => ({}), // 默認空對象
      },
    },
    components: {
      InputSwitch,
      Dropdown,
      MultiSelect,
      Card,
      InputNumber,
      InputText,
      Button,
      Loading,
    },
    data() {
      return {
        useDynBudget: false,
        useBenefits: { name: "" }, // 初始化為空值
        benefits: [{ name: "autoturn" }, { name: "futurelab" }],
        keyInBenefits: "",
        useInvestment: { name: "" }, // 初始化為空值
        investment: [{ name: "autoturn" }, { name: "futurelab" }],
        keyInInvestment: "",
        benefitsId: null,
        benefitsName: null,
        investmentId: null,
        investmentName: null,
        selectedType: { label: '個人或商家驗證', value: 1 }, // 用戶選擇的類型（受益者 / 出資者）
        options: [
          { label: '個人或商家驗證', value: 1 },
          { label: '企管平台驗證', value: 2 }
        ],
        personalShow: true,
        businessShow: false,
        investmentSelectedType: null,
        investmentOptions: [
          { label: '一', value: '1' },
          { label: '二', value: '2' }
        ],
        benefitsSelectedType: null,
        benefitsOptions: [
          { label: '三', value: '3' },
          { label: '四', value: '4' }
        ],
        keyInBenefits: false,
        keyInInvestment: false,
        showDsaLoading: true,
        regulatedCountryOptions: [],
      };
    },
    created() {

    },
    watch:{
      locale: {
        handler() {
          this.fetchRegulatedCountries()
        },
        immediate: true,
      },
      lang: {
        handler(newLang) {
          if (newLang?.components?.Event?.BenefitsAndInvestment) {
            const bi = newLang.components.Event.BenefitsAndInvestment;
            this.options[0].label = bi.person_verification;
            this.options[1].label = bi.business_verification;
            if (this.selectedType) {
              this.selectedType.label = this.selectedType.value === 1 ? bi.person_verification : bi.business_verification;
            }
          }
        },
        immediate: true
      },
      'viewDatalistData':function(v){
      //  console.log('viewDatalistData');
      //  console.log(v);
      },
      'viewDatalistData.person_or_business': function(v){
      //  console.log('viewDatalistData.person_or_business', v);
        if(v.value === 2){
          this.personalShow = false;
          this.businessShow = true;
        } else {
          this.personalShow = true;
          this.businessShow = false;
        }
      },
      'benefitsSelectedType': function(v){
        if(v != null){
          this.benefitsId = null;
          this.benefitsName = null;
        }
      },
      'benefitsId': function(v){
        if(v != null){
          this.benefitsSelectedType = null;
        }
      },
      'benefitsName': function(v){
        if(v != null){
          this.benefitsSelectedType = null;
        }
      },
      'investmentSelectedType': function(v){
        if(v != null){
          this.investmentId = null;
          this.investmentName = null;
        }
      },
      'investmentId': function(v){
        if(v != null){
          this.investmentSelectedType = null;
        }
      },
      'investmentName': function(v){
        if(v != null){
          this.investmentSelectedType = null;
        }
      },
    },
    methods: {
      fetchRegulatedCountries(){
        const locale = this.locale
        axios.post('https://www.autoturn.net/api/campaign_form_regulated_countries.php', Qs.stringify({
          s_code: this.$route.params.id,
          lang: locale,
        })).then((response) => {
          if(this.locale === locale && response.data.status === 'success'){
            this.regulatedCountryOptions = Array.isArray(response.data.return_data) ? response.data.return_data : []
          }
        })
      },
      submitData() {
        alert(`提交的 ID: ${this.idNumber}, 名稱: ${this.idName}`);
      },
      clearData() {
        this.idNumber = null;
        this.idName = '';
      },
      setBenefits(){
      //  console.log('setBenefits');
        if (this.keyInBenefits) {
          let checkBenefits = false;
          // console.log(this.viewDatalistData.domain_list);
          // console.log(this.domain);
          for (let i = 0; i < this.viewDatalistData.benefits_list.length; i++) {
            if (this.viewDatalistData.benefits_list[i].name === this.keyInBenefits) {
              checkBenefits = true
            }
          }

          if(checkBenefits == false){
            let newOpt = { name: this.keyInBenefits };
            this.viewDatalistData.benefits_list.push(newOpt);
            // this.transformDomain = newOpt;
            this.viewDatalistData.viewDatalistData.benefits_list = newOpt;
          }
        }
      },
      setInvestment(){
      //  console.log('setInvestment');
        if (this.keyInInvestment) {
          let checkInvestment = false;
          // console.log(this.viewDatalistData.domain_list);
          // console.log(this.domain);
          for (let i = 0; i < this.viewDatalistData.investment_list.length; i++) {
            if (this.viewDatalistData.investment_list[i].name === this.keyInInvestment) {
              checkInvestment = true
            }
          }

          if(checkInvestment == false){
            let newOpt = { name: this.keyInInvestment };
            this.viewDatalistData.investment_list.push(newOpt);
            // this.transformDomain = newOpt;
            this.viewDatalistData.investment = newOpt;
          }
        }
      },
      dsa_entities_update(){
        this.showDsaLoading = false;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_dsa_entities.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            update_type: true
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.viewDatalistData.benefits_list = response.data.return_data
              this.viewDatalistData.investment_list = response.data.return_data
            }

            this.showDsaLoading = true;
          });
      },
      dsa_identities_update(){
        this.showDsaLoading = false;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_dsa_identities.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            update_type: true
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.viewDatalistData.beneOrPayerPersonalList = response.data.return_data
            }

            this.showDsaLoading = true;
          });
      },
      isChangeData(type){
        console.log('isChangeData', type);
        switch(type){
          case 'b':
            if(this.viewDatalistData.selectedBeneficiary != null && this.viewDatalistData.selectedBeneficiary != '' && typeof this.viewDatalistData.selectedBeneficiary != 'undefined'){
              this.viewDatalistData.selectedBeneficiary = null;
            }
            break;

          case 'p':
            if(this.viewDatalistData.selectedPayer != null && this.viewDatalistData.selectedPayer != '' && typeof this.viewDatalistData.selectedPayer != 'undefined'){
              this.viewDatalistData.selectedPayer = null;
            }
            break;
        }
      },
      onBeneficiaryChange(newVal) {
        // if (newVal !== this.viewDatalistData.selectedBeneficiary) {
          // console.log("选中的 Beneficiary 变更为:", newVal);
          // this.viewDatalistData.selectedBeneficiary = newVal; // 更新值
          this.viewDatalistData.beneficiary_name = null;
          this.viewDatalistData.beneficiary_id = null;
        // }
      },
      onPayerChange(newVal) {
        // if (newVal !== this.viewDatalistData.selectedPayer) {
          // console.log("选中的 Payer 变更为:", newVal);
          // this.viewDatalistData.selectedPayer = newVal; // 更新值
          this.viewDatalistData.payer_name = null;
          this.viewDatalistData.payer_id = null;
        // }
      },
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.calendar-group) {
    .p-calendar .p-inputtext {
      padding: 0.25rem;
      border: 0px;
    }
  }
</style>
